import { Box, Typography } from '@mui/material';
import { CallIcons, User } from '../ccf-call-conference.slice';
import {
  CcfCallRecordIcon,
  CcfCallControls,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import classes from '../ccf-call-conference.module.scss';

interface UserInConsultProps {
  icons: CallIcons[];
  user?: User;
}

/**
 * Component used to show user in consullt
 * @param props - UserInConsultProps
 * @example <UserInConsult />
 * @returns
 */
export const UserInConsult = (props: UserInConsultProps) => {
  const { icons, user } = props;

  return (
    <Box>
      {user && (
        <>
          <Box px={0.5} width="100%" display="flex" alignItems="center">
            <CcfCallRecordIcon
              viewBox="0 0 20 20"
              color="primary"
              classes={{ root: classes.userInConsultRecordIcon }}
              fontSize="small"
            />
            <Typography
              classes={{ root: classes.userInConsultTypography }}
              noWrap
              variant="subtitle2"
              component="span"
            >
              {user.name}
            </Typography>
            <CcfTypography translationKey="inConsult" variant="caption" />
          </Box>
          <CcfCallControls icons={icons} />
        </>
      )}
    </Box>
  );
};
